import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  Customer,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useCustomer = (
  gatewayEndPoint: string,
  customerUuid: string,
): [Customer, NotificationData] => {
  const [customer, setCustomer] = React.useState(null);
  const [customerNotification, setCustomerNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getCustomer = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      // Get the Customer
      const customerOject: Customer = await api.customer.getCustomerV41(customerUuid);

      Logging.Info('Get Customer:', customerOject);

      setCustomer(customerOject);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Customer Read Error',
        description: 'Unable to read Customer',
        error: error as ResponseError,
      };
      setCustomerNotification(notification);
    }
  };

  React.useEffect(() => {
    Logging.Debug('Load Customer:', customerUuid);

    // Customer Uuuid is specified
    if (customerUuid) {
      // Correct Customer already loaded
      if (customer && (customer.customerUuid === customerUuid)) {
        // Do Nothing
      } else {
        dispatch(getCustomer());
      }
    } else {
      setCustomer(null);
    }

    return (): void => {
      setCustomerNotification(null);
    };
  }, [customerUuid]);

  return [customer, customerNotification];
};

export default useCustomer;
